export enum LocaleActionTypes {
  SET_LOCALE = 'SET_LOCALE'
}

export type AllowedLocale = 'en' | 'he';

export type SetLocaleAction = {
  type: LocaleActionTypes.SET_LOCALE,
  payload: AllowedLocale
};

export type LocaleAction = SetLocaleAction;


